<template>
    <section>
        <!-- 検索窓 -->
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;" v-loading="toolbarLoading">
            <el-form :inline="true" :model="filters">
                <el-form-item>
                    <el-select v-model="filters.user" placeholder="コンテンツ種別">
                        <el-option value=""></el-option>
                        <el-option v-for="item in allUsers"
                                   :key="item.id"
                                   :value="item.id"
                                   :label="item.name">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="filters.name" placeholder="コンテンツ名（部分一致）" style="width: 180px;"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" v-on:click="getContents">検索</el-button>
                    <el-button type="primary" v-on:click="exportCsv" v-if="adminRole">CSV出力</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleAdd">新規追加</el-button>
                </el-form-item>
                <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="30"
                           :total="total" style="float:right;">
                </el-pagination>
            </el-form>
        </el-col>
        <!-- /検索窓 -->

        <!-- リスト -->
        <el-table :data="contents" highlight-current-row v-loading="listLoading" @selection-change="selsChange"
                  style="width: 100%;">
            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column prop="user" label="コンテンツ種別" width="160" sortable>
            </el-table-column>
            <el-table-column prop="name" label="コンテンツ名" width="300" sortable>
            </el-table-column>
            <el-table-column prop="paidFlag" label="コンテンツ有償・無償" width="200" align="center" sortable>
                <template scope="scope">
                    {{ getPaidFlagName(scope.row.paidFlag) }}
                </template>
            </el-table-column>
            <el-table-column prop="url" label="URL" width="600">
                <template scope="scope">
                    smps-app://5g?type=interactive&contentsid={{scope.row.id }}
                </template>
            </el-table-column>
            <el-table-column width="50">
                <template scope="scope">
                    <el-button size="small" @click="copyUrl(scope.row.id)">
                        <i class="el-icon-document"></i>
                    </el-button>
                </template>
            </el-table-column>
            <el-table-column prop="publishBegin" label="公開日時" width="300" sortable>
                <template scope="scope">
                    {{ scope.row.publishBegin | formatDate }} - {{ scope.row.publishEnd | formatDate }}
                </template>
            </el-table-column>
            <el-table-column prop="fiveGChannelId" label="5GチャンネルID" width="210" sortable>
                <template scope="scope">
                    {{ scope.row.fiveGChannelId }}
                </template>
            </el-table-column>
            <el-table-column prop="updatedAt" label="更新日時" width="210" sortable>
                <template scope="scope">
                    {{ scope.row.updatedAt | formatDate }}
                </template>
            </el-table-column>
            <el-table-column label="操作" width="150">
                <template scope="scope">
                    <el-button size="small" @click="handleEdit(scope.$index, scope.row)">編集</el-button>
                    <el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)">削除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- /リスト -->

        <!-- 一括削除 -->
        <el-col :span="24" class="toolbar">
            <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">一括削除</el-button>
        </el-col>
        <!-- /一括削除 -->

        <!-- 編集画面 -->
        <el-dialog title="編集" v-model="editFormVisible" :close-on-click-modal="false" @close="closeEditForm">
            <el-form :model="editForm" label-width="120px" :rules="editFormRules" ref="editForm">
                <el-form-item label="ID" prop="id">
                    <el-input v-model="editForm.id" disabled></el-input>
                </el-form-item>
                <el-form-item label="コンテンツ名" prop="name">
                    <el-input v-model="editForm.name" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="説明文" prop="description">
                    <el-input
                            type="textarea"
                            :rows="3"
                            v-model="editForm.description">
                    </el-input>
                </el-form-item>
                <el-form-item label="動画1" prop="mainMovieId">
                    <el-select v-model="editForm.mainMovieId" filterable clearable placeholder="動画1"
                               value-key="id">
                        <el-option value=""></el-option>
                        <el-option v-for="item in allMovies"
                                   v-if="item.status == 'completed'"
                                   :key="item.id"
                                   :value="item.id"
                                   :label="formatMovieName(item.name, item.mode, item.contents)">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="動画2" prop="mainMovieId2">
                    <el-select v-model="editForm.mainMovieId2" filterable clearable placeholder="動画2">
                        <el-option value=""></el-option>
                        <el-option v-for="item in allMovies"
                                   v-if="item.status == 'completed'"
                                   :key="item.id"
                                   :value="item.id"
                                   :label="formatMovieName(item.name, item.mode, item.contents)">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="優先順位" prop="priority">
                    <el-input-number v-model="editForm.priority"></el-input-number>
                </el-form-item>
                <el-form-item label="公開日時">
                    <el-date-picker type="datetime"
                                    placeholder="開始日時"
                                    format="yyyy/MM/dd HH:mm"
                                    v-model="editForm.publishBegin">
                    </el-date-picker>
                    〜
                    <el-date-picker type="datetime"
                                    placeholder="終了日時"
                                    format="yyyy/MM/dd HH:mm"
                                    v-model="editForm.publishEnd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="シリーズ">
                    <el-select v-model="editForm.seriesId" clearable placeholder="選択して下さい">
                        <el-option value=""></el-option>
                        <el-option v-for="item in allSeries"
                                   :key="item.id"
                                   :value="item.id"
                                   :label="item.name">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="カテゴリ" prop="relationCategories">
                    <el-select v-model="editForm.relationCategories" multiple placeholder="選択して下さい">
                        <el-option v-for="item in allCategories"
                                   :key="item.id"
                                   :value="item.id"
                                   :label="item.name">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="コンテンツ種別" prop="users">
                    <el-select v-model="editForm.users" multiple placeholder="選択して下さい">
                        <el-option value=""></el-option>
                        <el-option v-for="item in allUsers"
                                   :key="item.id"
                                   :value="item.id"
                                   :label="item.name">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="画像" prop="imageId">
                    <el-select v-model="editForm.imageId" filterable clearable placeholder="選択して下さい" style="width: 100%;"
                               value-key="id">
                        <el-option
                                v-for="image in allImages"
                                :key="image.id"
                                :value="image.id"
                                :label="image.name">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="コンテンツID" prop="contentsId" v-if="editForm.contentsId">
                    <el-input v-model="editForm.contentsId"
                              disabled
                    ></el-input>
                </el-form-item>
                <div class="frame">
                    <div class="label">スマパスアプリ専用項目</div>
                    <el-form-item label="スマパスNo" prop="cinnamonContentsId">
                        <el-input v-model="editForm.cinnamonContentsId"
                                  auto-complete="off"
                                  :disabled="isDisable"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="コンテンツ有償無償" prop="paidFlag">
                        <el-radio-group v-model="editForm.paidFlag">
                            <el-radio label="1">有償</el-radio>
                            <el-radio label="0">無償</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
                <el-form-item label="5GチャンネルID" prop="fiveGChannelId">
                    <el-input v-model="editForm.fiveGChannelId"
                              disabled
                    ></el-input>
                </el-form-item>
                <el-form-item label="作成日時">
                    <el-date-picker type="datetime"
                                    placeholder="作成日時"
                                    format="yyyy/MM/dd HH:mm"
                                    v-model="editForm.createdAt"
                                    disabled>
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="更新日時">
                    <el-date-picker type="datetime"
                                    placeholder="更新日時"
                                    format="yyyy/MM/dd HH:mm"
                                    v-model="editForm.updatedAt"
                                    disabled>
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="closeEditForm">取消</el-button>
                <el-button type="primary" @click.native="editSubmit" :loading="editLoading">登録</el-button>
            </div>
        </el-dialog>
        <!-- /編集画面 -->

        <!-- 新規追加 -->
        <el-dialog title="新規追加" v-model="addFormVisible" :close-on-click-modal="false" @close="closeAddForm">
            <el-form :model="addForm" label-width="120px" :rules="addFormRules" ref="addForm">
                <el-form-item label="コンテンツ名" prop="name">
                    <el-input v-model="addForm.name" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="説明文" prop="description">
                    <el-input
                            type="textarea"
                            :rows="3"
                            v-model="addForm.description">
                    </el-input>
                </el-form-item>
                <el-form-item label="動画1" prop="mainMovieId">
                    <el-select v-model="addForm.mainMovieId" filterable clearable placeholder="動画1">
                        <el-option value=""></el-option>
                        <el-option v-for="item in allMovies"
                                   v-if="item.status == 'completed'"
                                   :key="item.id"
                                   :value="item.id"
                                   :label="formatMovieName(item.name, item.mode, item.contents)">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="動画2" prop="mainMovieId2">
                    <el-select v-model="addForm.mainMovieId2" filterable clearable placeholder="動画2">
                        <el-option value=""></el-option>
                        <el-option v-for="item in allMovies"
                                   v-if="item.status == 'completed'"
                                   :key="item.id"
                                   :value="item.id"
                                   :label="formatMovieName(item.name, item.mode, item.contents)">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="優先順位" prop="priority">
                    <el-input-number v-model="addForm.priority"></el-input-number>
                </el-form-item>
                <el-form-item label="公開日時">
                    <el-date-picker type="datetime"
                                    placeholder="開始日時"
                                    format="yyyy-MM-dd HH:mm"
                                    v-model="addForm.publishBegin">
                    </el-date-picker>
                    〜
                    <el-date-picker type="datetime"
                                    placeholder="終了日時"
                                    format="yyyy-MM-dd HH:mm"
                                    v-model="addForm.publishEnd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="シリーズ">
                    <el-select v-model="addForm.seriesId" clearable placeholder="選択して下さい">
                        <el-option value=""></el-option>
                        <el-option v-for="item in allSeries"
                                   :key="item.id"
                                   :value="item.id"
                                   :label="item.name">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="カテゴリ" prop="relationCategories">
                    <el-select v-model="addForm.relationCategories" multiple placeholder="選択して下さい">
                        <el-option value=""></el-option>
                        <el-option v-for="item in allCategories"
                                   :key="item.id"
                                   :value="item.id"
                                   :label="item.name">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="コンテンツ種別" prop="users">
                    <el-select v-model="addForm.users" multiple placeholder="選択して下さい">
                        <el-option value=""></el-option>
                        <el-option v-for="item in allUsers"
                                   :key="item.id"
                                   :value="item.id"
                                   :label="item.name">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="画像" prop="imageId">
                    <el-select v-model="addForm.imageId" filterable clearable placeholder="選択して下さい" style="width: 100%;"
                               value-key="id">
                        <el-option
                                v-for="image in allImages"
                                :key="image.id"
                                :value="image.id"
                                :label="image.name">
                        </el-option>
                    </el-select>
                </el-form-item>
                <div class="frame">
                    <div class="label">スマパスアプリ専用項目</div>
                    <el-form-item label="スマパスNo" prop="cinnamonContentsId">
                        <el-input v-model="addForm.cinnamonContentsId" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="コンテンツ有償無償" prop="paidFlag">
                        <el-radio-group v-model="addForm.paidFlag">
                            <el-radio label="1">有償</el-radio>
                            <el-radio label="0">無償</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="closeAddForm">取消</el-button>
                <el-button type="primary" @click.native="addSubmit" :loading="addLoading">登録</el-button>
            </div>
        </el-dialog>
        <!-- /新規追加 -->

    </section>
</template>

<script>
    import * as ContentRequest from '../../api/content';
    import * as UserRequest from '../../api/user';
    import * as CategoryRequest from '../../api/category';
    import * as SeriesRequest from '../../api/series';
    import * as MovieRequest from '../../api/movie';
    import * as ImageRequest from '../../api/image';
    import ElOption from "../../../node_modules/element-ui/packages/select/src/option.vue";
    import ElIcon from "../../../node_modules/element-ui/packages/icon/src/icon.vue";
    import config from '../../config/app';
    import { formatDate } from "../../components/filters/format";
    import { formatMode } from "../../components/filters/format";
    import moment from "moment";
    import * as User from '../../api/cognitoUser';

    export default {
        components: { ElOption, ElIcon },
        filters: { formatDate, formatMode },
        data() {
            return {
                filters: {
                    user: '',
                    name: ''
                },
                config: config,

                contents: [],
                allMovies: [],
                allUsers: [],
                allSeries: [],
                allCategories: [],
                allImages: [],
                total: 0,
                page: 1,
                listLoading: false,
                sels: [],
                adminRole: User.checkAdminRoleBySession(),
                toolbarLoading: false,
                allContentTotal: 0,

                // 編集系
                editFormVisible: false,
                isDisable:false,
                editLoading: false,
                editFormRules: {
                    name: [
                        { required: true, message: 'コンテンツ名を入力してください', trigger: 'blur' },
                        { max: 512, message: '512文字以内で入力してください', trigger: 'blur' },
                    ],
                    priority: [
                        { required: true, type: "number", message: '優先順位を入力してください', trigger: 'blur' }
                    ],
                    description: [
                        { required: true, message: '説明文を入力してください', trigger: 'blur' },
                        { max: 2048, message: '2048文字以内で入力してください', trigger: 'blur' },
                    ],
                    relationCategories: [
                        { required: true, type: "array", message: 'カテゴリを選択してください', trigger: 'blur' }
                    ],
                    imageId: [
                        { required: true, message: '画像を選択してください', trigger: 'change' }
                    ],
                    mainMovieId: [
                        { required: true, message: '動画を選択してください', trigger: 'change' }
                    ],
                    cinnamonContentsId: [
                        { validator: this.validateId, trigger: "blur" },
                        { min: 13, message: '13文字で入力してください', trigger: 'blur' },
                        { max: 13, message: '13文字で入力してください', trigger: 'blur' },
                    ],
                    users: [
                        { required: true, type: "array",　message: 'コンテンツ種別を選択してください', trigger: 'blur' }
                    ],
                },
                editForm: {
                    id: '',
                    name: '',
                    mainMovieId: '',
                    mainMovieId2: '',
                    description: '',
                    copyright: '',
                    priority: '99',
                    publishBegin: '',
                    publishEnd: '',
                    seriesId: '',
                    relationCategories: [],
                    createdAt: '',
                    updatedAt: '',
                    imageId: '',
                    cinnamonContentsId: '',
                    contentsId: '',
                    paidFlag: '',
                    fiveGChannelId: '',
                },

                // 新規系
                addFormVisible: false,
                addLoading: false,
                addFormRules: {
                    name: [
                        { required: true, message: 'コンテンツ名を入力してください', trigger: 'blur' },
                        { max: 512, message: '512文字以内で入力してください', trigger: 'blur' },
                    ],
                    priority: [
                        { required: true, type: "number", message: '優先順位を入力してください', trigger: 'blur' }
                    ],
                    description: [
                        { required: true, message: '説明文を入力してください', trigger: 'blur' },
                        { max: 2048, message: '2048文字以内で入力してください', trigger: 'blur' },
                    ],
                    relationCategories: [
                        { required: true, type: "array", message: 'カテゴリを選択してください', trigger: 'blur' }
                    ],
                    imageId: [
                        { required: true, message: '画像を選択してください', trigger: 'change' }
                    ],
                    mainMovieId: [
                        { required: true, message: '動画を選択してください', trigger: 'change' }
                    ],
                    cinnamonContentsId: [
                        { validator: this.validateId, trigger: "blur" },
                        { min: 13, message: '13文字で入力してください', trigger: 'blur' },
                        { max: 13, message: '13文字で入力してください', trigger: 'blur' },
                    ],
                    users: [
                        { required: true, type: "array",　message: 'コンテンツ種別を選択してください', trigger: 'blur' }
                    ],
                },
                addForm: {
                    name: '',
                    mainMovieId: '',
                    mainMovieId2: '',
                    description: '',
                    copyright: '',
                    priority: '99',
                    publishBegin: '',
                    publishEnd: '',
                    seriesId: '',
                    relationCategories: [],
                    imageId: '',
                    cinnamonContentsId: '',
                    paidFlag: '1',
                }
            }
        },
        methods: {
            validateId(rule, value, callback) {
              if(value === null) {
                //編集時にCinnamonID未入力の場合
                callback();
              }else {
                if (!value.match(/^[0-9]*$/)) {
                    callback(new Error("半角数字を入力してください。"));
                } else {
                    callback();
                }
              }
            },
            formatMovieName(name, mode, contents) {
                const registered = contents.length > 0 ? " (使用中）" : ""
                return name + " (" + formatMode(mode) + ")" + registered
            },
            handleCurrentChange(val) {
                this.page = val;
                this.getContents();
            },
            getContents() {
                let params = {
                    params: {
                        fields: "name",
                        q: this.filters.name,
                        order: "priority",
                        sort: "asc",
                        order2: "createdAt",
                        sort2: "desc",
                        count: config.pageCount,
                        offset: (this.page - 1) * config.pageCount,
                        user: this.filters.user,
                    }
                };
                this.listLoading = true;
                ContentRequest.count(params)
                    .then(res => {
                        this.total = res.data.count;
                    });
                ContentRequest
                    .search(params)
                    .then(res => {
                        this.contents = res.data.map(content => {
                            if (content.mainMovie) {
                                content.mainMovieId = content.mainMovie.id;
                            }
                            if (content.mainMovie2) {
                                content.mainMovieId2 = content.mainMovie2.id;
                            }
                            if (content.series) {
                                content.seriesId = content.series.id;
                            }
                            if (content.categories) {
                                content.category = content.categories.map(c => {
                                    return c.name;
                                }).join(" / ");
                                content.categories = content.categories.map(category => {
                                    return category.id;
                                })
                            }
                            if (content.relationCategories) {
                              content.relationCategory = content.relationCategories.map(c => {
                                return c.name;
                              }).join(" / ");
                              content.relationCategories = content.relationCategories.map(relationCategory => {
                                return relationCategory.id;
                              })
                            }
                            if (content.users) {
                                content.user = content.users.map(user => {
                                    return user.name;
                                }).join(" / ");
                                content.users = content.users.map(user => {
                                    return user.id;
                                })
                            }
                            if (content.images) {
                                content.thambnail = Object.assign(content.images, {});
                                content.images = content.images.map(img => {
                                    return img.id
                                })
                            }
                            return content;
                        });
                        this.listLoading = false;
                    });
            },
            getCategories() {
                CategoryRequest.all()
                    .then(res => {
                      this.allCategories = res.data.relationCategories;
                      this.categoryIds = res.data.categories.map(category => category.id)
                    });
            },
            getSeries() {
                SeriesRequest.all()
                    .then(res => {
                        this.allSeries = res.data;
                    });
            },
            getUsers() {
                UserRequest.all()
                    .then(res => {
                        this.allUsers = res.data;
                    });
            },
            getApps() {
                const param = {
                    params: {
                        order: "updatedAt",
                        sort: "DESC",
                        count: 0
                    }
                }
                MovieRequest.search(param)
                    .then(res => {
                        this.allMovies = res.data;
                    })
            },
            getImages() {
                ImageRequest
                    .all()
                    .then(res => {
                        this.allImages = res.data;
                    });
            },
            handleDel: function (index, row) {
                this.$confirm('削除してもよろしいですか？', '確認', { type: 'warning' })
                    .then(() => {
                        this.listLoading = true;
                        return ContentRequest.remove(row.id, {})
                        .then(() => {
                            this.$message({
                                message: '削除しました',
                                type: 'success'
                            })
                        })
                        .catch(() => {
                            this.$message({
                                message: '優先表示動画に設定されているため削除できません',
                                type: 'error'
                            })
                        })
                    })
                    .then(() => {
                        this.listLoading = false;
                        this.getContents();
                    })
            },
            handleEdit: function (index, row) {
                this.editFormVisible = true;
                const rowObj = Object.assign({}, row);
                rowObj.imageId = rowObj.images[0];
                rowObj.paidFlag = rowObj.paidFlag ? '1' : '0';
                this.editForm = rowObj;
                this.isDisable=!!rowObj.cinnamonContentsId;
            },
            handleAdd: function () {
                this.addFormVisible = true;
                this.addForm = {
                    name: '',
                    mainMovieId: '',
                    mainMovieId2: '',
                    description: '',
                    copyright: '',
                    priority: '99',
                    publishBegin: '',
                    publishEnd: '',
                    seriesId: '',
                    relationCategories: [],
                    users: this.filters.user ? [this.filters.user] : [],
                    imageId: '',
                    cinnamonContentsId: '',
                    paidFlag: '1',
                };
            },
            closeAddForm() {
                this.$refs.addForm.resetFields();
                this.addFormVisible = false;
            },
            closeEditForm() {
                this.$refs.editForm.resetFields();
                this.editFormVisible = false;
            },
            editSubmit: function () {
                this.$refs.editForm.validate(valid => {
                    if (valid) {
                        this.$confirm('登録してもよろしいですか？', '確認', {})
                            .then(() => {
                                this.editLoading = true;
                                this.editForm.categories = this.categoryIds
                                const params = Object.assign({}, this.editForm);
                                params.images = [params.imageId];
                                delete params.imageId;
                                return ContentRequest.edit(this.editForm.id, params);
                            })
                            .then((res) => {
                                this.editLoading = false;
                                if (!!res.data && !!res.data.title) {
                                    const h = this.$createElement;
                                    this.$message({
                                        type: "warning",
                                        duration: 5000,
                                        message: h("div", null, [
                                            h("div", null, res.data.title),
                                            h("ul", null, [
                                                h("li", null, res.data.message),
                                            ])
                                        ])
                                    });
                                } else {
                                    this.$message({
                                        message: '登録しました',
                                        type: 'success'
                                    });
                                }
                                this.closeEditForm();
                                this.getContents();
                            })
                            .catch(() => {
                                this.editLoading = false;
                            });
                    }
                });
            },
            addSubmit: function () {
                this.$refs.addForm.validate(valid => {
                    if (valid) {
                        this.$confirm('登録してもよろしいですか？', '確認', {})
                            .then(() => {
                                this.addLoading = true;
                                this.addForm.categories = this.categoryIds
                                const params = Object.assign({}, this.addForm);
                                params.images = [params.imageId];
                                delete params.imageId;
                                return ContentRequest.add(params)
                            })
                            .then((res) => {
                                this.addLoading = false;
                                if (!!res.data && !!res.data.title) {
                                    const h = this.$createElement;
                                    this.$message({
                                        type: "warning",
                                        duration: 5000,
                                        message: h("div", null, [
                                            h("div", null, res.data.title),
                                            h("ul", null, [
                                                h("li", null, res.data.message),
                                            ])
                                        ])
                                    });
                                } else {
                                    this.$message({
                                        message: '登録しました',
                                        type: 'success'
                                    });
                                }
                                this.closeAddForm();
                                this.getContents();
                            })
                            .catch(() => {
                                this.addLoading = false;
                            });
                    }
                });
            },
            selsChange: function (sels) {
                this.sels = sels;
            },
            batchRemove: function () {
                const ids = this.sels.map(item => item.id);
                this.$confirm('選択した項目を削除してもよろしいですか？', '確認', { type: 'warning' })
                    .then(() => {
                        this.listLoading = true;
                        return ContentRequest.batchRemove(ids, {})
                        .then(res => {
                            this.listLoading = false;
                            this.$message({
                                message: '削除しました',
                                type: 'success'
                            })
                        })
                        .catch(() => {
                            this.$message({
                                message: '一部削除できませんでした。',
                                type: 'error'
                            })
                        })
                    })
                    .then(() => {
                        this.listLoading = false;
                        this.getContents();
                    })
            },
            copyUrl(id) {
                const url = `smps-app://5g?type=interactive&contentsid=${id}`
                navigator.clipboard.writeText(url)
                .then(() => {
                    this.$message({
                        message: 'コピーしました。',
                        type: 'success'
                    })
                })
                .catch(() => {
                    this.$message({
                        message: 'コピーに失敗しました。',
                        type: 'error'
                    })
                })
            },
            exportCsv: async function() {
                this.listLoading = true;
                this.toolbarLoading = true;
                // ヘッダ行
                const columns = [
                    'NO.',
                    'URL',
                    'コンテンツ名',
                    'コンテンツ有償・無償',
                    '説明文',
                    '動画１',
                    '動画２',
                    '動画３',
                    '動画４',
                    '優先順位',
                    '公開日時from',
                    '公開日時to',
                    'シリーズ',
                    'カテゴリ',
                    'コンテンツ種別',
                    '画像',
                    '字幕',
                    'スマパスNo',
                    'コンテンツID',
                    '画像ファイル名',
                    '動画１_ID',
                    '動画２_ID',
                    '動画３_ID',
                    '動画４_ID',
                    '作成日時',
                    '更新日時',
                ];
                const header = columns.join(',') + '\n';

                // データ取得（全件）
                ContentRequest.count()
                        .then(res => {
                            this.allContentTotal = res.data.count;
                        });
                const content = await this.getAllContent(0);

                let arrContent = [];
                for (var i = 0; i < content.length; i++) {
                    const category = content[i].relationCategories.map(category => {
                        return category.name;
                    }).join(",");
                    const user = content[i].users.map(user => {
                        return user.name;
                    }).join(",");

                    const data = [
                        i + 1,
                        'smps-app://5g?type=interactive&contentsid=' + content[i].id,
                        '"' + content[i].name.replace(/"/g, '""') + '"',
                        this.getPaidFlagName(content[i].paidFlag),
                        '"' + content[i].description.replace(/"/g, '""') + '"',
                        content[i].mainMovie ? content[i].mainMovie.name: '',
                        content[i].mainMovie2 ? content[i].mainMovie2.name: '',
                        content[i].mainMovie3 ? content[i].mainMovie3.name: '',
                        content[i].mainMovie4 ? content[i].mainMovie4.name: '',
                        content[i].priority,
                        content[i].publishBegin ? formatDate(content[i].publishBegin): '',
                        content[i].publishEnd ? formatDate(content[i].publishEnd): '',
                        content[i].series ? '"' + content[i].series.name.replace(/"/g, '""') + '"': '',
                        '"' + category.replace(/"/g, '""') + '"',
                        '"' + user.replace(/"/g, '""') + '"',
                        content[i].images[0] ? content[i].images[0].name: '',
                        '',
                        content[i].cinnamonContentsId ? content[i].cinnamonContentsId: '',
                        content[i].id,
                        content[i].images[0] ? content[i].images[0].path: '',
                        content[i].mainMovie ? content[i].mainMovie.id: '',
                        content[i].mainMovie2 ? content[i].mainMovie2.id: '',
                        content[i].mainMovie3 ? content[i].mainMovie3.id: '',
                        content[i].mainMovie4 ? content[i].mainMovie4.id: '',
                        formatDate(content[i].createdAt),
                        formatDate(content[i].updatedAt),
                    ];
                    arrContent.push(data);
                }
                const body = arrContent.join('\n');

                // CSVダウンロード
                const iconv = require("iconv-lite");
                const data = iconv.encode(header + body, 'windows-31j');
                const blob = new Blob([ data ], { "type" : "text/csv" });
                const url = window.URL.createObjectURL(blob);

                let link = document.createElement('a');
                link.download = 'swipe_content_' + moment().format("YYYYMMDD") + '.csv';
                link.href = url;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                this.listLoading = false;
                this.toolbarLoading = false;
            },
            getAllContent: async function(offset) {
                const recordCount = 30;     // 1回のAPIで取得する最大レコード数
                const params = {
                    params: {
                        order: 'updatedAt',
                        sort: 'DESC',
                        count: recordCount,
                        offset: offset,
                    }
                };
                const content = await ContentRequest
                        .search(params)
                        .then(res => {
                            return res.data;
                        });

                if (offset + recordCount >= this.allContentTotal) {
                    return content;
                }

                // API負荷分散の為、再帰的に一定件数を取得
                const nextItems = await this.getAllContent(offset + recordCount);
                Array.prototype.push.apply(content, nextItems);
                return content;
            },
            getPaidFlagName: function(paidFlag) {
                return paidFlag ? '有償' : '無償';
            }
        },
        mounted() {
            this.getContents();
            this.getSeries();
            this.getCategories();
            this.getUsers();
            this.getApps();
            this.getImages();
        }
    }

</script>

<style scoped>
    div.frame {
        border-top: 2px solid #b1b1b1;
        border-bottom: 2px solid #b1b1b1;
        margin: 30px 0 30px 0;
        padding: 5px 0 5px 0;
    }
    div.frame div.label {
        margin-bottom: 10px;
        font-weight: bold;
    }
</style>


// WEBPACK FOOTER //
// List.vue?3eaaf0cf